import Vue from 'vue';
import Router from 'vue-router';

Vue.use(Router);

const isWeixin = function () { //判断是否是微信
    var ua = navigator.userAgent.toLowerCase();
    return ua.match(/MicroMessenger/i) == "micromessenger";
};
const router = new Router({
    mode: "hash",
    routes: [{
            path: "/",
            name: 'register',
            component: () => import('@/components/register.vue')
        },
        {
            path: '/DownApp',
            name: 'downApp',
            component: () => import('./components/downApp.vue')
        },
        {
            path: '/userInfo',
            name: 'userInfo',
            component: () => import('./components/userInfo.vue')
        },
        {
            path: '/yszc',
            name: 'yszc',
            component: () => import('./components/yszc.vue')
        },{
            path: '/goWeb',
            name: 'goWeb',
            component: () => import('./components/goWeb.vue')
        }
    ]
});

router.beforeEach((to, from, next) => {
    if (isWeixin() && to.name != 'goWeb') {
        next({
            path: '/goWeb',
            query: to.query
        });
        
    } else {
        next();
    }
    console.log(to, from, next);
})

export default router;